export default "__VITE_ASSET__ClyZw0Qy__"